import { render } from "./ShiftsOverview.vue?vue&type=template&id=47f9e461&scoped=true&ts=true"
import script from "./ShiftsOverview.vue?vue&type=script&lang=ts"
export * from "./ShiftsOverview.vue?vue&type=script&lang=ts"

import "./ShiftsOverview.vue?vue&type=style&index=0&id=47f9e461&scoped=true&lang=scss"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f9e461"]])

export default __exports__